export default __webpack_public_path__ + "static/media/FIFA - Logo.d30a462e.png";